module.exports = __webpack_public_path__ + "static/media/mprserv_121.ceec0159.ico";